export default {
  Contract: 'Contract',
  'To generate the contract please press the button below.':
    'To generate the contract please press the button below.',
  'Generate contract': 'Generate contract',
  'Review the generated document and upload the signed contract photos in the area below.':
    'Review the generated document and upload the signed contract photos in the area below.',
  'Download contract': 'Download contract',
  'Sign and submit': 'Sign and submit',
  'Authorised signatory': 'Authorised signatory',
  'Feel free to select another authorised signatory. Contract will be re-generated with new data.':
    'Feel free to select another authorised signatory. Contract will be re-generated with new data.',
  'Choose another person': 'Choose another person',
  'Choose person': 'Choose person',
  'Send invitation': 'Send invitation',
  'Resend invitation': 'Resend invitation',
  'View contract': 'View contract',
  'Send invitation to:': 'Send invitation to:',
  'We will send the invitation link to log in to the Portal.':
    'We will send the invitation link to log in to the Portal.',
  'Who will sign the contract?': 'Who will sign the contract?',
  'Select authorised signatory': 'Select authorised signatory',
  'To successfully submit the signed agreement, please do not reload the page or close the tab until the end of the authentication process. Any uploaded documents will be lost if the page is reloaded, or the tab is closed.':
    'To successfully submit the signed agreement, please do not reload the page or close the tab until the end of the authentication process. Any uploaded documents will be lost if the page is reloaded, or the tab is closed.',
  'To submit the contract, please complete the Nafath biometric authentication process. Ensure you have access to the Nafath application and press the “Continue” button below when you are ready to proceed.':
    'To submit the contract, please complete the Nafath biometric authentication process. Ensure you have access to the Nafath application and press the “Continue” button below when you are ready to proceed.',
  'Submitting contract': 'Submitting contract',
  'You rejected the Network International Arabia request in the Nafath application. Please try again to proceed.':
    'You rejected the Network International Arabia request in the Nafath application. Please try again to proceed.',
  'You rejected the request in Nafath. Please try again.': 'You rejected the request in Nafath. Please try again.',
  'You have {{count}} attempts left._one': 'You have {{count}} attempt left.',
  'You have {{count}} attempts left._other': 'You have {{count}} attempts left.',
  'The Nafath biometric authentication retry is temporary locked. Please wait before trying again.':
    'The Nafath biometric authentication retry is temporary locked. Please wait before trying again.',
  'The Nafath biometric authentication session is expired. Please try again to proceed.':
    'The Nafath biometric authentication session is expired. Please try again to proceed.',
  'The Nafath authentication session has expired. Please try again.': 'The Nafath authentication session has expired. Please try again.',
  'Please <1>Contact us</1> or try again later.': 'Please <1>Contact us</1> or try again later.',
  'The Nafath biometric authentication retry limits have been reached and your account is permanently locked. <1>Contact us</1> to unlock your account.':
    'The Nafath biometric authentication retry limits have been reached and your account is permanently locked. <1>Contact us</1> to unlock your account.',
  'Please generate the contract to proceed.': 'Please generate the contract to proceed.',
  'Please accept the Network International Arabia request in the Nafath application and match the number displayed below with the one shown in the app.':
    'Please accept the Network International Arabia request in the Nafath application and match the number displayed below with the one shown in the app.',
  'Reset counter': 'Reset counter',
  '{{attemptsUsed}} out of {{attemptsMax}}': '{{attemptsUsed}} out of {{attemptsMax}}',
  'Your request session will expire in': 'Your request session will expire in',
  'Try again to complete the authentication in': 'Try again to complete the authentication in',
  'Full name': 'Full name',
  'Current signature': 'Current signature',
  Counter: 'Counter',
  'Are you sure?': 'Are you sure?',
  'Do you want to reset couner for {{name}}?': 'Do you want to reset couner for {{name}}?',

  // ── Agreement pricing amendment (NASSC-19394) ──
  'Amend Agreement Pricing': 'Amend Agreement Pricing',
  'Submit for approval': 'Submit for approval',
  Minimum: 'Minimum',
  'Percentage only': 'Percentage only',
  'Fixed only': 'Fixed only',
  'Percentage + Fixed': 'Percentage + Fixed',
  'Percentage plus fixed': 'Percentage plus fixed',
  'This field is required.': 'This field is required.',
  'Enter a whole number — decimals are not allowed.':
    'Enter a whole number — decimals are not allowed.',
  'Must be at least {{min}} {{currency}}.':
    'Must be at least {{min}} {{currency}}.',
  'Must be at least {{min}}%.': 'Must be at least {{min}}%.',
  'Both fields are below the minimum — at least {{minP}}% and {{min}} {{currency}}.':
    'Both fields are below the minimum — at least {{minP}}% and {{min}} {{currency}}.',
  'Percentage must be at least {{min}}%.':
    'Percentage must be at least {{min}}%.',
  'Amount must be at least {{min}} {{currency}}.':
    'Amount must be at least {{min}} {{currency}}.',
  'Value is required': 'Value is required',
  'Value must be a whole number (INTEGER)': 'Value must be a whole number (INTEGER)',
  'Value is not within the acceptable range. Minimum: {{min}} {{currency}}':
    'Value is not within the acceptable range. Minimum: {{min}} {{currency}}',
  'Value is not within the acceptable range. Minimum: {{min}}%':
    'Value is not within the acceptable range. Minimum: {{min}}%',
  'Value is not within the acceptable range. Minimum: {{minP}}% + {{min}} {{currency}}':
    'Value is not within the acceptable range. Minimum: {{minP}}% + {{min}} {{currency}}',
  'Pricing submitted for Sales Manager approval': 'Pricing submitted for Sales Manager approval',
  'Failed to submit pricing': 'Failed to submit pricing',
  'Pricing submitted and pending Sales Manager approval. Fields are locked until a decision is made.':
    'Pricing submitted and pending Sales Manager approval. Fields are locked until a decision is made.',
  'Pricing approved. Fields are locked.': 'Pricing approved. Fields are locked.',
  'Pricing approved. You may still amend fees and resubmit for another review.':
    'Pricing approved. You may still amend fees and resubmit for another review.',
  'Pricing was rejected. You may amend and resubmit.':
    'Pricing was rejected. You may amend and resubmit.',
  'Agreement pricing is not available for this application.':
    'Agreement pricing is not available for this application.',
  'No editable pricing fields available for the selected product(s).':
    'No editable pricing fields available for the selected product(s).',
  'Pricing submitted and pending approval. You may amend and resubmit, or approve.':
    'Pricing submitted and pending approval. You may amend and resubmit, or approve.',
  'Pricing submitted and pending approval. You may amend fees before approving or rejecting.':
    'Pricing submitted and pending approval. You may amend fees before approving or rejecting.',
  'Pricing submitted and pending Sales Manager approval. You may amend and resubmit.':
    'Pricing submitted and pending Sales Manager approval. You may amend and resubmit.',
  Approve: 'Approve',
  Reject: 'Reject',
  'Approve or reject': 'Approve or reject',
  'Reason for rejection': 'Reason for rejection',
  'A rejection reason is required': 'A rejection reason is required',
  'Pricing approved. The merchant has been notified.':
    'Pricing approved. The merchant has been notified.',
  'Failed to approve pricing': 'Failed to approve pricing',
  'Failed to reject pricing': 'Failed to reject pricing',
  'Pricing rejected. The amendment has been returned to the agent.':
    'Pricing rejected. The amendment has been returned to the agent.',
  'Credit Card fee type': 'Credit Card fee type',

  // ── Agreement pricing field labels ──
  POS: 'POS',
  ECOM: 'ECOM',
  Ecom: 'ECOM',
  setupFee: 'Setup Fee',
  monthlyFee: 'Monthly Fee',
  madaTransactionsLessThan100: 'mada transactions less than SAR 100',
  madaTransactions100OrAbove: 'mada transactions SAR 100 or above',
  madaPerTransaction: 'mada (per transaction)',
  gccCardsPerTransaction: 'GCC Cards per transaction',
  creditCardPerTransaction: 'Credit Card per transaction',
  minimumUsageFeePerPosDevice:
    'Minimum usage fee per POS device (if the monthly sales value below SAR 15,000)',
  fundsTransferFees: 'Funds Transfer Fees',
  fundsTransferFee: 'Funds Transfer Fee',

  // ── Agent Contract View ──
  Agreement: 'Agreement',
  'Signatory Details': 'Signatory Details',
  'Signatory Name': 'Signatory Name',
  'Signatory National ID': 'Signatory National ID',
  'Signatory IP Address': 'Signatory IP Address',
  'Applicant Details': 'Applicant Details',
  'Applicant Name': 'Applicant Name',
  'Applicant Mobile Number': 'Applicant Mobile Number',
  'Applicant National ID': 'Applicant National ID',
  'Agreement Details': 'Agreement Details',
  'Signed Contract': 'Signed Contract',
  'File Name': 'File Name',
  'Contract Version Number': 'Contract Version Number',
  'Agreement Acceptance Date & Time': 'Agreement Acceptance Date & Time',
  'Nafath Verification Date & Time': 'Nafath Verification Date & Time',
  'Contract Reviewed by Agent': 'Contract Reviewed by Agent',
  'Upload File': 'Upload File',
  Confirm: 'Confirm',
};
